export const ApiDef_AIPrompt = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map